const CountCartItems = () => {
  const cart = JSON.parse(localStorage.checkout);
  let total = 0;
  for (let i = 0; i < cart.length; i++) {
    total = cart[i].qt + total;
  };

  return total;
};

export default CountCartItems;


// WEBPACK FOOTER //
// ./src/components/CountCartItems.js